import { StyledExtraContentContainer } from "./styled";

const ExtraContentContainer = ({ text }) => (
  <StyledExtraContentContainer>{text}</StyledExtraContentContainer>
);

export default ExtraContentContainer;
